<template>
  <div class="comment-item">
    <div class="user">
      <img :class="['avatar', type]" :src="item.userAvatar" alt="">
      <div class="info">
        <p class="name">
          <span>{{item.userName}}</span>
          <template v-if="item.isOwner">
            <i class="icon owner">提问人</i>
          </template>
          <template v-else>
            <i :class="[item.role, 'icon identity']"></i>
          </template>
        </p>
        <p class="title">{{item.hospitalName}} {{item.title}}</p>
      </div>
    </div>
    <div class="content">
      <span class="reply" v-if="!!item.receiverId">回复<i>@{{item.receiverName}}</i></span>
      {{item.comment}}
    </div>
    <div class="action">
      <div class="time">
        <span class="text">{{item.createdDate}} · </span>
        <span class="reply" @click.stop="replyAction">回复</span>
      </div>
      <div class="like" :class="{ active: item.approved }" @click.stop="likeAction(item)">
        <i></i>
        <span v-show="item.approvalCount">{{ item.approvalCount }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, getCurrentInstance } from 'vue'
import { exerReq } from '@/api'
import { Toast } from 'vant'
export default defineComponent({
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    remarkId: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: ''
    }
  },
  setup(props, cxt) {
    const { proxy: { $showLoading, $hideLoading } } = getCurrentInstance()
    const replyAction = () => {
      // console.log(props.type)
      let obj = Object.assign({}, props.item, {
        showReplyMask: true,
        replyType: props.type === 'remark' ? 1 : 2
      });
      cxt.emit('reply', obj)
    }

    const likeAction = async (item) => {
      $showLoading()
      let msg = item.approved ? '取消点赞成功' : '点赞成功'
      exerReq.postRemarkLike({
        commentType: item.commentType || 'REMARK',
        targetId: item.nagId || item.messageId || item.remarkId
      }).then(res => {
        $hideLoading()
        if (res.code === 200) {
          Toast(msg)
          cxt.emit('like', item)
        } else {
          Toast(res.message)
        }
      })
    }

    return {
      replyAction,
      likeAction
    }
  }
})

</script>

<style lang="scss" scoped>
.comment-item {
  margin-bottom: 20px;
  .user {
    display: flex;
    margin-bottom: 16px;
    .avatar {
      &.message {
        width: 40px;
        height: 40px;
      }
      &.remark {
        width: 56px;
        height: 56px;
      }
      border-radius: 50%;
      display: inline-block;
      margin-right: 16px;
    }
    .info {
      .name {
        display: flex;
        align-items: center;
        span {
          display: inline-block;
          color: #212224;
          font-size: 28px;
          margin-right: 8px;
        }
        .icon {
          display: inline-block;
          &.owner {
            color: #FF6600;
            font-size: 24px;
            padding: 4px 14px;
            background-color: rgba($color: #FF6600, $alpha: 0.2);
            border-radius: 4px;
            font-style: normal;
          }
          &.identity {
            width: 100px;
            height: 40px;
            background-size: cover;
            &.ASSISTANT {
              background-image: url('../img/question_assistant_icon.png');
            }
            &.LECTURER {
              background-image: url('../img/question_lector_icon.png');
            }
            &.COACH {
              background-image: url('../img/question_coach_icon.png');
            }
          }
        }
      }
      .title {
        color: #969799;
        font-size: 24px;
      }
    }
  }
  .content {
    padding-left: 56px;
    color: #626366;
    font-size: 28px;
    line-height: 40px;
    margin-bottom: 16px;

    .reply {
      i {
        font-style: normal;
        color: #6183F2;
      }
    }
  }

  .action {
    padding-left: 56px;
    display: flex;
    justify-content: space-between;
    .time {
      font-size: 24px;
      .text {
        color: #969799;
      }
      .btn {
        color: #626366;
      }
    }
    .like {
      display: flex;
      align-items: center;
      i {
        display: inline-block;
        margin-right: 8px;
        background-size: cover;
        height: 32px;
        width: 32px;
        background-image: url('~@/components/exercise/img/question_like_icon.png');
      }
      span {
        color: #969799;
        font-size: 24px;
      }
      &.active {
        i {
          background-image: url('~@/components/exercise/img/question_like_active_icon.png');
        }
      }
    }
  }
}
</style>
